import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1442362897262914';
const CHECKOUT_URL = 'https://www.cleverpockets.com/cart/44891884650632:1';
export function handleCTAClick(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();
  // Method 1: Use fbq if available
  try {
    const fbq = (window as any).fbq;
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_name: 'Who Programmed You to Spend?',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
  } catch (err) {
    // silent
  }
  // Method 2: Fire tracking pixel image as backup (always works)
  try {
    const img = new Image(1, 1);
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=AddToCart&cd[content_name]=Who+Programmed+You+to+Spend&cd[content_type]=product&cd[value]=6.39&cd[currency]=USD&noscript=1&t=${Date.now()}`;
  } catch (err) {
    // silent
  }
  // Redirect after giving pixel time to fire
  setTimeout(() => {
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  }, 400);
}
export function MetaPixel() {
  useEffect(() => {
    // Don't re-init if already loaded
    if ((window as any).fbq) return;
    // Inject the exact Facebook pixel snippet
    const script = document.createElement('script');
    script.textContent = ['!function(f,b,e,v,n,t,s)', '{if(f.fbq)return;n=f.fbq=function(){n.callMethod?', 'n.callMethod.apply(n,arguments):n.queue.push(arguments)};', 'if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";', 'n.queue=[];t=b.createElement(e);t.async=!0;', 't.src=v;s=b.getElementsByTagName(e)[0];', 's.parentNode.insertBefore(t,s)}(window,document,"script",', '"https://connect.facebook.net/en_US/fbevents.js");', 'fbq("init","' + PIXEL_ID + '");', 'fbq("track","PageView");'].join('');
    document.head.appendChild(script);
    // Noscript fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.setAttribute('alt', '');
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    document.body.appendChild(img);
  }, []);
  return null;
}